exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-title-avatar-custom{height:100%;padding:0 16px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.bordered{border-left:4px solid;border-top-left-radius:40px!important;border-bottom-left-radius:40px!important}.bordered,.bordered-flat{border-top:4px solid;border-bottom:4px solid}", ""]);

// exports
